import React from 'react';
import { ArrowRight, LucideIcon } from 'lucide-react';
import { motion } from 'motion/react';

interface ActivityCardProps {
  title: string;
  description: string;
  icon?: LucideIcon;
  image?: string;
  detailed?: boolean;
  onLearnMore?: () => void;
}

const ActivityCard: React.FC<ActivityCardProps> = ({ title, description, icon: Icon, image, detailed = false, onLearnMore }) => {
  return (
    <motion.div
      whileHover={{ y: -10 }}
      className={`bg-white rounded-3xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden group flex flex-col h-full`}
    >
      {image && (
        <div className="h-48 overflow-hidden relative">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            referrerPolicy="no-referrer"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent"></div>
        </div>
      )}
      
      <div className="p-8 flex-grow flex flex-col">
        {Icon && !image && (
          <div className="w-14 h-14 bg-blue-50 rounded-2xl flex items-center justify-center text-primary mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
            <Icon size={28} />
          </div>
        )}
        
        <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-primary transition-colors">
          {title}
        </h3>
        
        <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-grow">
          {description}
        </p>
        
        {detailed && (
          <button 
            onClick={onLearnMore}
            className="flex items-center space-x-2 text-primary font-bold text-sm group/btn hover:text-blue-800 transition-colors"
          >
            <span>Saiba mais</span>
            <ArrowRight size={16} className="group-hover/btn:translate-x-1 transition-transform" />
          </button>
        )}
      </div>
    </motion.div>
  );
};

export default ActivityCard;
